import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { UpgradingTechnology } from '../types';

export function useUpgradingTechnology() {
  const [t] = useTranslation(['projects']);

  const options = useMemo(
    () => [
      { label: 'Membrane', value: 'membrane' as UpgradingTechnology },
      { label: 'Water Scrubbing', value: 'water_scrubbing' as UpgradingTechnology },
      { label: 'PSA', value: 'psa' as UpgradingTechnology },
    ],
    [t]
  );

  const kv = useMemo(
    () => options.reduce((map, option) => ({ ...map, [option.value]: option.label }), {}) as Record<string, string>,
    [options]
  );

  const map = useCallback((value?: string | null) => (value ? kv[value] : null), [kv]);

  return { options, kv, map };
}
